<template>
  <tr>
    <td>{{ npp }}</td>
    <td>{{ prod.id }}</td>
    <td v-if="key_name === 'product_link'">
      <div class="image">
        <img v-if="prod.product_link.prod_image && prod.product_link.prod_image.file_url" :src="prod.product_link.prod_image.file_url" :alt="prod.product_link.prod_name" />
        <div v-else class="placeholder">нет картинки</div>
      </div>
    </td>
    <td v-else>
      <div class="image">
        <img v-if="thumbnail" :src="thumbnail" :alt="prod.product.prod_name" />
        <div v-else class="placeholder">нет картинки</div>
      </div>
    </td>
    <td v-if="key_name==='product'" colspan="2">
      {{ prod.product.prod_name }}<br />
      <small>{{ prod.product.group.group_name }}</small>
    </td>
    <td v-else  colspan="2">
      {{ prod.product_link.prod_name }}<br />
      <small>Магазин: {{ prod.product_link.shop && prod.product_link.shop.shop_name }}</small><br />
      <small v-if="prod.product_link.prod_link">
        <a :href="prod.product_link.prod_link" target="_blank">
          {{ prod.product_link.prod_link }}
        </a>
      </small>
    </td>
    <td v-if="key_name==='product_link'">
      {{ prod.product_link.note }}
    </td>
    <td v-if="is_admin && key_name === 'product'">{{ supplier }}</td>

    <td>{{ prod[key_name].mnf_code }}</td>
    <td>{{ prod[key_name].weight || "0.00" }}</td>
    <td class="want">{{ prod.quan }}</td>
    <td class="want">{{ row_weight }}</td>
    <td class="fact">{{ prod.quan_fct }}</td>
    <td class="fact">{{ row_weight_fct }}</td>
    <td>
      {{ prod.price }}

      <span v-if="discount">
        <i :id="popover_id" class="fas fa-tags hoverable"></i>
        <b-popover :target="popover_id" triggers="hover" placement="righttop">
          <template #title>Товар со скидкой</template>
          {{ discount }}
          <div>{{ original_price }}</div>
        </b-popover>
      </span>
    </td>
    <td class="want">{{ total }}</td>
    <td class="fact">{{ total_fct }}</td>
    <td>{{ prod.price_with_vat }}</td>
    <td>{{ total_with_vat }}</td>
    <td width="40">
      <button v-if="can_delete"
        class="btn btn-sm sm-override btn-danger"
        @click="delPosition(prod.id, key_name)"
      >
        <i class="fas fa-trash-alt"></i>
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  name: "Position",
  props: [
    "npp",
    "is_admin",
    "prod",
    "key_name",
    "delPosition",
    "changeQuan",
    "can_delete",
    "can_change_fact",
    "updateQuanFct"
  ],
  data: () => ({
    quan_fct: 0,
    save_enabled: false
  }),
  created() {
    if (this.prod.quan_fct) this.quan_fct = this.prod.quan_fct;
  },
  computed: {
    discount() {
      const { discount_info } = this.prod;
      if(discount_info) {
        const value = Number(discount_info.discount_value);
        if(value > 0 && value !== this.prod.price) {
          const sign = discount_info.discount_type === 'simple' ? 'EUR' : '%';
          return `Скидка: ${value} ${sign}`;
        }
      }
      return null;
    },
    original_price() {
      const { discount_info } = this.prod;
      return `Цена без скидки: ${discount_info.original_price}`;
    },
    popover_id() {
      return `prod-${this.prod.id}`;
    },
    row_weight() {
      return Number(this.prod.quan) > 0 && Number(this.prod[this.key_name].weight) > 0
        ? (Number(this.prod.quan) * Number(this.prod[this.key_name].weight)).toFixed(2)
        : "0.0";
    },
    row_weight_fct() {
      return Number(this.prod.quan_fct) > 0 && Number(this.prod[this.key_name].weight) > 0
        ? (Number(this.prod.quan_fct) * Number(this.prod[this.key_name].weight)).toFixed(2)
        : "0.0";
    },
    supplier() {
      if (this.key_name === "product") {
      // console.log(this.prod[this.key_name], this.prod[this.key_name].product)
        return this.prod[this.key_name].supplier
          ? this.prod[this.key_name].supplier.sup_name
          : "-";
      }
      return "";
    },
    total() {
      return (this.prod.quan * this.prod.price).toFixed(2);
    },
    total_fct() {
      return (this.prod.quan_fct * this.prod.price).toFixed(2);
    },
    total_with_vat() {
      return (this.prod.quan * this.prod.price_with_vat).toFixed(2);
    },
    vat_rate() {
      return this.prod.vat_rate ? `${this.prod.vat_rate}%` : "н/д";
    },
    vat_sum() {
      return (this.prod.price_with_vat - this.prod.price).toFixed(2);
    },
    thumbnail() {
      if (this.prod.product.images.length === 0) return;
      return this.prod.product.images[0].thumbURL;
    }
  },
  watch: {
    quan_fct: function(newVal) {
      this.save_enabled = Number(newVal) !== this.prod.quan_fct ? true : false;
      this.quan_fct = Number(newVal);
    }
  },
  methods: {
    discardEdit() {
      if (this.prod.quan_fct) {
        this.quan_fct = this.prod.quan_fct;
      } else {
        this.quan_fct = 0;
      }
      this.save_enabled = false;
    },
    saveQuan() {
      this.updateQuanFct(this.prod.id, this.quan_fct);
      this.save_enabled = false;
    }
  }
};
</script>

<style lang="sass">
.image
  height: 60px
  display: flex
  justify-content: center
  align-items: center
  img
    max-width: 60px
    max-height: 60px

</style>
